export default __webpack_public_path__ + "static/media/2015.cbeebf55.png";